'use strict';

module.exports = 'data-reactid';


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-three-renderer/lib/utils/idPropertyName.js
 ** module id = 76
 ** module chunks = 0
 **/